import { JsonApiQuery } from '@nx-icilalune/data/access';
import { Client } from '@nx-icilalune/data/icilalune/types';
import {
  associatedProjectsIncludes,
  projetRelationAttributeEnhancers,
} from './icilalune.queries';
import { ImageMedia, SvgMedia } from '@nx-icilalune/drupal-types';

const clientIncludes = ['logo.fileRef'];
export const homeSectionClientListQuery: JsonApiQuery = {
  queryId: 'homeSectionClientListQuery',
  type: Client.type,
  include: clientIncludes,
  filters: { ['promote']: '1', isPublished: '1' },
  sort: [
    { field: 'isPromoted', direction: 'DESC' },
    { field: 'field_client_start', direction: 'DESC' },
  ],
  fields: {
    [Client.type]: ['title', 'path', 'langcode', 'logo'],
    [SvgMedia.type]: ['fileRef', 'langcode'],
    ['files']: ['uri'],
  },
  page: {
    limit: 6,
    offset: 0,
  },
  relationAttributeEnhancers: ['logo.fileRef'],
};

export const clientListQuery: JsonApiQuery = {
  queryId: 'clientListQuery',
  type: Client.type,
  include: clientIncludes,
  page: {
    limit: 15,
    offset: 0,
  },
  sort: [
    { field: 'isPromoted', direction: 'DESC' },
    { field: 'field_client_start', direction: 'DESC' },
  ],
  relationAttributeEnhancers: ['logo.fileRef'],
  editable: true,
  paging: true,
  filters: {
    isPublished: '1',
  },
};

export const clientDetailQuery: JsonApiQuery = {
  queryId: 'clientDetailQuery',
  type: Client.type,
  include: [...clientIncludes, ...associatedProjectsIncludes],
  page: {
    limit: 20,
    offset: 0,
  },
  relationAttributeEnhancers: [
    'logo.fileRef',
    ...projetRelationAttributeEnhancers,
  ],
  filters: {
    isPublished: '1',
  },
};
